import { HiOutlineArrowLeft, HiOutlineChevronRight, HiOutlineDocumentText, HiOutlineUpload } from 'react-icons/hi';

import {
  BackButton,
  FormBody,
  StepTitle,
  StepSubtitle,
  TypeCard,
  TypeCardArrow,
  TypeCardContent,
  TypeCardIcon,
  TypeCardsWrapper,
  TypeCardSubtitle,
  TypeCardTitle,
  TypeCardWarning,
} from './styles';

interface StepSendTypeProps {
  hasCnaes: boolean;
  onSelectManual: () => void;
  onSelectUpload: () => void;
  onBack: () => void;
}

export const StepSendType = ({ hasCnaes, onSelectManual, onSelectUpload, onBack }: StepSendTypeProps) => {
  return (
    <FormBody>
      <BackButton type="button" onClick={onBack}>
        <HiOutlineArrowLeft />
        Voltar
      </BackButton>

      <StepTitle>Como deseja enviar?</StepTitle>
      <StepSubtitle>
        Toque em uma das opções abaixo para continuar.
      </StepSubtitle>

      <TypeCardsWrapper>
        <TypeCard
          type="button"
          $disabled={!hasCnaes}
          onClick={hasCnaes ? onSelectManual : undefined}
        >
          <TypeCardIcon>
            <HiOutlineDocumentText />
          </TypeCardIcon>
          <TypeCardContent>
            <TypeCardTitle>Preencher manualmente</TypeCardTitle>
            <TypeCardSubtitle>
              Preencha os dados de cada nota fiscal, um por um
            </TypeCardSubtitle>
            {!hasCnaes && (
              <TypeCardWarning>
                Indisponível — nenhum código de serviço foi cadastrado pelo contador
              </TypeCardWarning>
            )}
          </TypeCardContent>
          {hasCnaes && (
            <TypeCardArrow>
              <HiOutlineChevronRight />
            </TypeCardArrow>
          )}
        </TypeCard>

        <TypeCard type="button" onClick={onSelectUpload}>
          <TypeCardIcon>
            <HiOutlineUpload />
          </TypeCardIcon>
          <TypeCardContent>
            <TypeCardTitle>Enviar planilha</TypeCardTitle>
            <TypeCardSubtitle>
              Envie um arquivo Excel ou CSV com todos os dados
            </TypeCardSubtitle>
          </TypeCardContent>
          <TypeCardArrow>
            <HiOutlineChevronRight />
          </TypeCardArrow>
        </TypeCard>
      </TypeCardsWrapper>
    </FormBody>
  );
};
